import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, Link, Route, Switch } from 'react-router-dom';
import Login from './pages/Auth/Login';
import RecoveryPassword from './pages/Auth/RecoveryPassword';
import MainTheme from './template/MainTheme';
import AppProvider from './contexts/AppContext';
import AuthProvider, { AuthContext } from './contexts/AuthContext';
import NotificationProvider from './contexts/NotificationContext';
import PrivateMiddleware from './routes/middleware/PrivateMiddleware';
import Pusher from 'pusher-js';
import Notifications from './pages/Notifications';
import useAuthService from './app/services/hooks/useAuthService';
import ForeignExchange from './pages/ForeignExchange';
import Client from './pages/Clients';
import ClientEditPage from './pages/Clients/subpages/ClientEditPage';
import Societies from './pages/Societies';
import Vehicles from './pages/Vehicles';
import Transports from './pages/Transports';
import TransportEdit from './pages/Transports/subpages/TransportEdit';
import User from './pages/Users';
import Provider from './pages/Providers';
import ProviderEditPage from './pages/Providers/subpages/ProviderEditPage';
import Quotes from './pages/Quotes';
import QuoteEdit from './pages/Quotes/subpages/QuoteEdit';
import QuoteShow from './pages/Quotes/subpages/QuoteShow';
import Dashboard from './pages/Dashboard';
import TransportationOrder from './pages/TransportationOrders';
import TransportationOrderEdit from './pages/TransportationOrders/subpages/TransportationOrderEdit';
import TransportationOrderShow from './pages/TransportationOrders/subpages/TransportationOrderShow';
import TransportOrder from './pages/TransportOrder';
import Afps from './pages/Afps';
import Provisions from './pages/Provisions';
import Banks from './pages/Banks';
import BankAccountTypes from './pages/BankAccountTypes';
import ProviderTypes from './pages/ProviderTypes';
import CarrierTypes from './pages/CarrierTypes';
import Units from './pages/Units';
import Products from './pages/Products';
import Brands from './pages/Brand';
import ItemCategories from './pages/ItemCategories';
import Locations from './pages/Locations';
import Sectors from './pages/Sectors';
import Qualities from './pages/Qualities';
import Colors from './pages/Colors';
import VehicleModels from './pages/VehicleModels';
import Currencies from './pages/Currencies';
import PaymentMethods from './pages/PaymentMethods';
import PaymentConditions from './pages/PaymentConditions';
import Incoterms from './pages/Incoterms';
import Groups from './pages/Groups';
import PublicMiddleware from './routes/middleware/PublicMiddleware';
import CheckingAccount from './pages/CheckingAccount';
import InternalSettlements from './pages/InternalSettlements';
import Profile from './pages/Profile/EditProfile';
import PasswordProfile from './pages/Profile/EditPassword';
import Workers from './pages/Workers';
import Shifts from './pages/Shifts';
import WorkersEdit from './pages/Workers/subpages/WorkersEdit';
import WorkersCalendar from './pages/Workers/subpages/WorkersCalendar';
import TransferReasons from './pages/TransferReasons';
import BankAccountReasons from './pages/BankAccountReasons';
import SocietySignatures from './pages/SocietySignature';
import DispatchPrograms from './pages/DispatchProgram';
import DispatchProgramEdit from './pages/DispatchProgram/subpages/DispatchProgramEdit';
import DispatchProgramShow from './pages/DispatchProgram/subpages/DispatchProgramShow';
import DailyCarriers from './pages/DailyCarriers';
import Document from './pages/Documents';
import DocumentSet from './pages/DocumentSets';
//import SocietiesEdit from './pages/Societies/subpages/SocietiesEdit';
import SocietyEdit from './pages/Societies/components/SocietyEdit';
import Accounts from './pages/Accounts';
import StatusHistories from './pages/StatusHistories';
import Clasifications from './pages/Clasifications';
import UnitEquivalence from './pages/UnitEquivalence';
import Contract from './pages/Contract';
import AfpEdit from './pages/Afps/components/subpages/AfpEdit';
import ProvisionEdit from './pages/Provisions/components/subpages/ProvisionEdit';
import IncidentReasons from './pages/IncidentReasons';
import MonthlyClosures from './pages/MonthlyClosures';
import MonthlyClosureEdit from './pages/MonthlyClosures/subpages/MonthlyClosureEdit';
import AITolls from './pages/AITolls';
import Funds from './pages/Funds';
import PaymentStatuses from './pages/PaymentStatus';
import PaymentStatusEdit from './pages/PaymentStatus/components/subpages/PaymentStatusEdit';
import SalesInvoices from './pages/SalesInvoice';
import SalesInvoiceEdit from './pages/SalesInvoice/components/subpages/SalesInvoiceEdit';
import CauseNotes from './pages/CauseNote';
import Taxes from './pages/Taxes';
import UnitConversions from './pages/UnitConversion';
import MonetaryMovements from './pages/MonetaryMovements';
import Batches from './pages/Batches';
import BatchesCollection from './pages/Batches/BatchesCollection';
import BatchesSelection from './pages/Batches/BatchesSelection';
import BatchesCommercial from './pages/Batches/BatchesCommercial';
import Centers from './pages/Centers';
import Warehouses from './pages/Warehouses';
import PackingOrders from './pages/PackingOrders';
import PackingOrderEditPage from './pages/PackingOrders/subpages/PackingOrderEditPage';
import Projects from './pages/Projects';
import CollectionOrders from './pages/CollectionOrders';
import CollectionOrderEdit from './pages/CollectionOrders/subpages/CollectionOrderEdit';
import CollectionOrderShow from './pages/CollectionOrders/subpages/CollectionOrderShow';
import SelectionOrders from './pages/SelectionOrders';
import SelectionOrderEdit from './pages/SelectionOrders/subpages/SelectionOrderEdit';
import SelectionOrderShow from './pages/SelectionOrders/subpages/SelectionOrderShow';
import BatchEdit from './pages/Batches/subpages/BatchEdit';
import BatchShow from './pages/Batches/subpages/BatchShow';
import PurchaseOrders from './pages/PurchaseOrder';
import PurchaseOrderEdit from './pages/PurchaseOrder/subpages/PurchaseOrderEdit';
import PurchaseOrderShow from './pages/PurchaseOrder/subpages/PurchaseOrderShow';
import ServiceManifests from './pages/ServiceManifest';
import ServiceManifestEdit from './pages/ServiceManifest/subpages/ServiceManifestEdit';
import ServiceManifestShow from './pages/ServiceManifest/subpages/ServiceManifestShow';
import PurchaseDocument from './pages/PurchaseDocument';
import PurchaseDocumentEdit from './pages/PurchaseDocument/components/subpages/PurchaseDocumentEdit';
import PurchaseDocumentShow from './pages/PurchaseDocument/components/subpages/PurchaseDocumentShow';
import CostCenters from './pages/CostCenters';
import Countries from './pages/Countries';
import Services from './pages/Services';
import BusinessNames from './pages/BusinessName';
import BusinessNameEdit from './pages/BusinessName/subpages/BusinessNameEdit';
import BusinessNameShow from './pages/BusinessName/subpages/BusinessNameShow';
import ContactTypes from './pages/ContactTypes';
import SalesOrders from './pages/SalesOrders';
import SalesOrderEditPage from './pages/SalesOrders/subpages/SalesOrderEdit';
import Deliveries from './pages/Deliveries';
import DeliveryEditPage from './pages/Deliveries/subpages/DeliveryEditPage';
import DeliveryView from './pages/Deliveries/subpages/DeliveryView';

// import { EndPoints } from './app/services/EndPoints';

export const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY || '', {
    cluster: process.env.REACT_APP_PUSHER_CLUSTER
    // userAuthentication: {
    //     endpoint: EndPoints.AUTH.PUSHER_AUTH,
    //     transport: "ajax",
    //     params: {},
    //     headers: {},
    //   },
});

export const channel = pusher.subscribe('notifications');

function App() {
    // const { getRoles } = useAuthService();

    // const [roles, setRoles] = useState<string[]>([]);
    // const [company, setCompany] = useState<string>('');

    // useEffect(() => {
    //     const path = window.location.pathname;
    //     if (path != '/login' && path != '/recovery-password') {
    //         getRoles({
    //             onSuccess: (response) => {
    //                 setRoles(response.data.roles);
    //                 setCompany(response.data.company);
    //             }
    //         });
    //     }
    // }, []);

    return (
        <Router>
            <AuthProvider>
                <AppProvider>
                    <NotificationProvider> 
                        <Switch>
                            <Route path="/login">
                                <PublicMiddleware>
                                    <MainTheme showLayouts={false}>
                                        <Login />
                                    </MainTheme>
                                </PublicMiddleware>
                            </Route>
                            <Route path="/recovery-password">
                                <PublicMiddleware>
                                    <MainTheme showLayouts={false}>
                                        <RecoveryPassword />
                                    </MainTheme>
                                </PublicMiddleware>
                            </Route>
                            <PrivateMiddleware>
                                <Switch>
                                    <Route path="/workers/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <WorkersEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/societies/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <SocietyEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/quotes/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <QuoteEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/incident-reasons">
                                        <MainTheme showLayouts={true}>
                                            <IncidentReasons />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/sales-invoices/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <SalesInvoiceEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/sales-invoices">
                                        <MainTheme showLayouts={true}>
                                            <SalesInvoices />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/transport-orders">
                                        <MainTheme showLayouts={true}>
                                            <TransportOrder />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/transportation-orders/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <TransportationOrderEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/transportation-orders/:id/show">
                                        <MainTheme showLayouts={true}>
                                            <TransportationOrderShow />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/transportation-orders">
                                        <MainTheme showLayouts={true}>
                                            <TransportationOrder />
                                        </MainTheme>
                                    </Route>

                                    <Route path="/batches/collection">
                                        <MainTheme showLayouts={true}>
                                            <BatchesCollection />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/batches/selection">
                                        <MainTheme showLayouts={true}>
                                            <BatchesSelection />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/batches/commercial">
                                        <MainTheme showLayouts={true}>
                                            <BatchesCommercial />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/clients/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <ClientEditPage />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/cause-notes">
                                        <MainTheme showLayouts={true}>
                                            <CauseNotes />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/batches">
                                        <MainTheme showLayouts={true}>
                                            <Batches />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/batch/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <BatchEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/batch/:id/show">
                                        <MainTheme showLayouts={true}>
                                            <BatchShow />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/projects">
                                        <MainTheme showLayouts={true}>
                                            <Projects />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/warehouses">
                                        <MainTheme showLayouts={true}>
                                            <Warehouses />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/packing-orders/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <PackingOrderEditPage />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/packing-orders">
                                        <MainTheme showLayouts={true}>
                                            <PackingOrders />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/centers">
                                        <MainTheme showLayouts={true}>
                                            <Centers />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/collection-orders">
                                        <MainTheme showLayouts={true}>
                                            <CollectionOrders />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/collection-order/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <CollectionOrderEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/collection-order/:id/show">
                                        <MainTheme showLayouts={true}>
                                            <CollectionOrderShow/>
                                        </MainTheme>
                                    </Route>
                                    <Route path="/selection-orders">
                                        <MainTheme showLayouts={true}>
                                            <SelectionOrders />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/selection-order/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <SelectionOrderEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/selection-order/:id/show">
                                        <MainTheme showLayouts={true}>
                                            <SelectionOrderShow/>
                                        </MainTheme>
                                    </Route>
                                    <Route path="/services">
                                        <MainTheme showLayouts={true}>
                                            <Services />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/purchase-orders/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <PurchaseOrderEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/purchase-orders/:id/show">
                                        <MainTheme showLayouts={true}>
                                            <PurchaseOrderShow />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/purchase-orders">
                                        <MainTheme showLayouts={true}>
                                            <PurchaseOrders />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/service-manifests/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <ServiceManifestEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/service-manifests/:id/show">
                                        <MainTheme showLayouts={true}>
                                            <ServiceManifestShow />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/service-manifests">
                                        <MainTheme showLayouts={true}>
                                            <ServiceManifests />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/purchase-documents/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <PurchaseDocumentEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/purchase-documents/:id/show">
                                        <MainTheme showLayouts={true}>
                                            <PurchaseDocumentShow />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/purchase-documents">
                                        <MainTheme showLayouts={true}>
                                            <PurchaseDocument />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/cost-centers">
                                        <MainTheme showLayouts={true}>
                                            <CostCenters />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/countries">
                                        <MainTheme showLayouts={true}>
                                            <Countries />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/contact-types">
                                        <MainTheme showLayouts={true}>
                                            <ContactTypes />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/business-names/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <BusinessNameEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/business-names/:id/show">
                                        <MainTheme showLayouts={true}>
                                            <BusinessNameShow />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/business-names">
                                        <MainTheme showLayouts={true}>
                                            <BusinessNames />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/taxes">
                                        <MainTheme showLayouts={true}>
                                            <Taxes />
                                        </MainTheme>
                                    </Route>

                                    <Route path="/monthly-closures/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <MonthlyClosureEdit/>
                                        </MainTheme>
                                    </Route>
                                    <Route path="/monthly-closures">
                                        <MainTheme showLayouts={true}>
                                            <MonthlyClosures/>
                                        </MainTheme>
                                    </Route>

                                    <Route path="/funds">
                                        <MainTheme showLayouts={true}>
                                            <Funds />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/users">
                                        <MainTheme showLayouts={true}>
                                            <User />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/vehicles">
                                        <MainTheme showLayouts={true}>
                                            <Vehicles />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/transports/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <TransportEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/transports">
                                        <MainTheme showLayouts={true}>
                                            <Transports />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/societies-signatures">
                                        <MainTheme showLayouts={true}>
                                            <SocietySignatures />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/societies">
                                        <MainTheme showLayouts={true}>
                                            <Societies />
                                        </MainTheme>
                                    </Route>

                                    <Route path="/clients">
                                        <MainTheme showLayouts={true}>
                                            <Client />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/documents">
                                        <MainTheme showLayouts={true}>
                                            <Document />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/document-sets">
                                        <MainTheme showLayouts={true}>
                                            <DocumentSet />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/quotes/:id/show">
                                        <MainTheme showLayouts={true}>
                                            <QuoteShow />
                                        </MainTheme>
                                    </Route>

                                    <Route path="/quotes">
                                        <MainTheme showLayouts={true}>
                                            <Quotes />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/quotes/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <QuoteEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/contracts">
                                        <MainTheme showLayouts={true}>
                                            <Contract />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/documents">
                                        <MainTheme showLayouts={true}>
                                            <Document />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/document-sets">
                                        <MainTheme showLayouts={true}>
                                            <DocumentSet />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/quotes/:id/show">
                                        <MainTheme showLayouts={true}>
                                            <QuoteShow />
                                        </MainTheme>
                                    </Route>

                                    <Route path="/quotes">
                                        <MainTheme showLayouts={true}>
                                            <Quotes />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/quotes/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <QuoteEdit />
                                        </MainTheme>
                                    </Route>

                                    <Route path="/payment-statuses/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <PaymentStatusEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/payment-statuses">
                                        <MainTheme showLayouts={true}>
                                            <PaymentStatuses />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/sales-orders/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <SalesOrderEditPage />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/sales-orders">
                                        <MainTheme showLayouts={true}>
                                            <SalesOrders />
                                        </MainTheme>
                                    </Route>

                                    <Route path="/deliveries/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <DeliveryEditPage />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/deliveries/:id/view">
                                        <MainTheme showLayouts={true}>
                                            <DeliveryView />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/deliveries">
                                        <MainTheme showLayouts={true}>
                                            <Deliveries />
                                        </MainTheme>
                                    </Route>

                                    <Route path="/providers/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <ProviderEditPage />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/providers">
                                        <MainTheme showLayouts={true}>
                                            <Provider />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/provider-types">
                                        <MainTheme showLayouts={true}>
                                            <ProviderTypes />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/carriers">
                                        <MainTheme showLayouts={true}>
                                            <Workers key="carriers" is_carrier={true} />
                                        </MainTheme>
                                    </Route>

                                    <Route path="/notifications">
                                        <MainTheme showLayouts={true}>
                                            <Notifications />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/dispatch-programs/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <DispatchProgramEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/dispatch-programs/:id/show">
                                        <MainTheme showLayouts={true}>
                                            <DispatchProgramShow />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/daily-carriers">
                                        <MainTheme showLayouts={true}>
                                            <DailyCarriers />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/dispatch-programs">
                                        <MainTheme showLayouts={true}>
                                            <DispatchPrograms />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/ai-tolls">
                                        <MainTheme showLayouts={true}>
                                            <AITolls />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/afps" exact>
                                        <MainTheme showLayouts={true}>
                                            <Afps />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/afps/:id/edit" exact>
                                        <MainTheme showLayouts={true}>
                                            <AfpEdit />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/workers">
                                        <MainTheme showLayouts={true}>
                                            <Workers key="workers" />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/shifts">
                                        <MainTheme showLayouts={true}>
                                            <Shifts />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/provisions" exact>
                                        <MainTheme showLayouts={true}>
                                            <Provisions />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/checking-accounts">
                                        <MainTheme showLayouts={true}>
                                            <CheckingAccount />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/internal-settlements">
                                        <MainTheme showLayouts={true}>
                                            <InternalSettlements />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/monetary-movements">
                                        <MainTheme showLayouts={true}>
                                            <MonetaryMovements />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/banks">
                                        <MainTheme showLayouts={true}>
                                            <Banks />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/transfer_reasons">
                                        <MainTheme showLayouts={true}>
                                            <TransferReasons />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/transfer_reasons">
                                        <MainTheme showLayouts={true}>
                                            <TransferReasons />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/bank-account-types">
                                        <MainTheme showLayouts={true}>
                                            <BankAccountTypes />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/bank-account-reasons">
                                        <MainTheme showLayouts={true}>
                                            <BankAccountReasons />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/accounts">
                                        <MainTheme showLayouts={true}>
                                            <Accounts />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/clasifications">
                                        <MainTheme showLayouts={true}>
                                            <Clasifications />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/products">
                                        <MainTheme showLayouts={true}>
                                            <Products />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/item-categories">
                                        <MainTheme showLayouts={true}>
                                            <ItemCategories />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/locations">
                                        <MainTheme showLayouts={true}>
                                            <Locations />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/sectors">
                                        <MainTheme showLayouts={true}>
                                            <Sectors />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/qualities">
                                        <MainTheme showLayouts={true}>
                                            <Qualities />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/colors">
                                        <MainTheme showLayouts={true}>
                                            <Colors />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/units">
                                        <MainTheme showLayouts={true}>
                                            <Units />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/unit-equivalence">
                                        <MainTheme showLayouts={true}>
                                            <UnitEquivalence />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/unit-conversions">
                                        <MainTheme showLayouts={true}>
                                            <UnitConversions />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/currencies">
                                        <MainTheme showLayouts={true}>
                                            <Currencies />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/payment-methods">
                                        <MainTheme showLayouts={true}>
                                            <PaymentMethods />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/payment-conditions">
                                        <MainTheme showLayouts={true}>
                                            <PaymentConditions />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/incoterms">
                                        <MainTheme showLayouts={true}>
                                            <Incoterms />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/foreign-exchanges">
                                        <MainTheme showLayouts={true}>
                                            <ForeignExchange />
                                        </MainTheme>
                                    </Route> 
                                    <Route path="/brands">
                                        <MainTheme showLayouts={true}>
                                            <Brands />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/vehicle-models">
                                        <MainTheme showLayouts={true}>
                                            <VehicleModels />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/roles">
                                        <MainTheme showLayouts={true}>
                                            <Groups />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/status-histories">
                                        <MainTheme showLayouts={true}>
                                            <StatusHistories />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/edit-profile">
                                        <MainTheme showLayouts={true}>
                                            <Profile />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/dashboard">
                                        <MainTheme showLayouts={true}>
                                            <Dashboard />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/">
                                        <MainTheme showLayouts={true}>
                                            <Dashboard />
                                        </MainTheme>
                                    </Route>
                                </Switch>
                            </PrivateMiddleware>
                        </Switch>
                        </NotificationProvider>
                </AppProvider>
            </AuthProvider>
        </Router>
    );
}

export default App;
